import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase";
import "../styles/Sidebar.css";
import MiniDash from "./MiniDash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faLandmark,
    faUserSecret,
    // faUserCog,
    // faPlugCircleBolt, 
    faFileShield,
    faGlobe,
    // faClipboardCheck, 
    faSignOutAlt,
    faCommentsDollar,
    faCircleDollarToSlot,
    faMoneyBill1
} from "@fortawesome/free-solid-svg-icons";
import { matchPath } from "react-router-dom";


function SideItem({ closeMenu }) {
    const navigate = useNavigate();
    const auth = getAuth();
    const [user, setUser] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(true);


    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (authUser) => {
            if (authUser) {
                setUser(authUser);
                const userDocRef = doc(db, "swiss-h", authUser.uid);
                const userDoc = await getDoc(userDocRef);

                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    setUserRole(userData.role || null);
                } else {
                    console.log("No user document found");
                }
            } else {
                setUser(null);
            }

            console.log("User state:", user);
        });

        return () => unsubscribe();
    }, [auth, user]);

    // Function to check if the current path matches the given path or pattern
    const isActive = (path) => {
        const match = matchPath(path, location.pathname);
        return match !== null;
    };

    const handleLogout = () => {
        signOut(auth)
            .then(() => {
                console.log("User signed out");
                navigate("/");
            })
            .catch((error) => console.error("Error signing out: ", error));
    };


    return (
        <div className="sidebars">
            <div className="userContainer">
                <MiniDash closeMenu={closeMenu} />
            </div>

            <div className="side-item">
                <Link
                    to="/"
                    className={`route-Links ${isActive("/") ? "active" : ""}`}
                    onClick={() => { closeMenu(); }}
                >
                    <FontAwesomeIcon icon={faLandmark} className="icon" /> Account Overview
                </Link>
            </div>

            {userRole === "admin" && (
                <div className="admin-drop-down-container">
                    <div
                        className="admin-dropdown-mobile"
                        onClick={toggleDropdown}
                    >
                        <FontAwesomeIcon icon={faUserSecret} className="icon" /> For Admin Only
                    </div>

                    {isOpen && (
                        <ul className="admin-drop-down-list">
                            <li className="admin-dropdown-item">
                                <Link
                                    to="/get-admin"
                                    className={`admin-link-mobile ${isActive("/get-admin") ? "active" : ""}`}>
                                    -  All Users
                                </Link>
                            </li>
                            <li className="admin-dropdown-item">
                                <Link
                                    to="/userdetail/add-transaction"
                                    className={`admin-link-mobile ${isActive("/userdetail/add-transaction") ? "active" : ""}`}>
                                    - Add Transaction
                                </Link>
                            </li>
                        </ul>
                    )}
                </div>

            )}

            <div className="side-item">
                <Link
                    to="/transfer"
                    className={`route-Links ${isActive("/transfer") ? "active" : ""}`}
                    onClick={() => { closeMenu(); }}
                >
                    <FontAwesomeIcon icon={faCommentsDollar} className="icon" /> Make a Transfer
                </Link>
            </div>

            <div className="side-item">
                <Link
                    to="/transactions"
                    className={`route-Links ${isActive("/transactions") ? "active" : ""}`}
                    onClick={() => { closeMenu(); }}
                >
                    <FontAwesomeIcon icon={faMoneyBill1} className="icon" /> All Transactions
                </Link>
            </div>

            <div className="side-item">
                <Link
                    to="/loans"
                    className={`route-Links ${isActive("/loans") ? "active" : ""}`}
                    onClick={() => { closeMenu(); }}
                >
                    <FontAwesomeIcon icon={faCircleDollarToSlot} className="icon" /> Get Loans
                </Link>
            </div>

            {/* <div className="side-item">
                <Link
                    to="/my-card"
                    className={`route-Links ${isActive("/my-card") ? "active" : ""}`}
                    onClick={() => { closeMenu(); }}
                >
                    <FontAwesomeIcon icon={faClipboardCheck} className="icon" /> My Cards
                </Link>
            </div> */}

            {/* <div className="side-item">
                <Link
                    to="/profile"
                    className={`route-Links ${isActive("/profile") ? "active" : ""}`}
                    onClick={() => { closeMenu(); }}
                >
                    <FontAwesomeIcon icon={faUserCog} className="icon" /> Profile
                </Link>
            </div> */}

            {/* <div className="side-item">
                <Link
                    to="/investments"
                    className={`route-Links ${isActive("/investments") ? "active" : ""}`}
                    onClick={() => { closeMenu(); }}
                >
                    <FontAwesomeIcon icon={faPlugCircleBolt} className="icon" /> Investments
                </Link>
            </div> */}

            <div className="side-item">
                <Link
                    to="/about-us"
                    className={`route-Links ${isActive("/about-us") ? "active" : ""}`}
                    onClick={() => { closeMenu(); }}
                >
                    <FontAwesomeIcon icon={faGlobe} className="icon" /> About Us
                </Link>
            </div>

            <div className="side-item">
                <Link
                    to="/terms"
                    className={`route-Links ${isActive("/terms") ? "active" : ""}`}
                    onClick={() => { closeMenu(); }}
                >
                    <FontAwesomeIcon icon={faFileShield} className="icon" /> Terms & Conditions
                </Link>
            </div>

            <div onClick={handleLogout} className="log-out">
                <FontAwesomeIcon icon={faSignOutAlt} className="icon" /> Logout
            </div>
        </div>
    );
}

export default SideItem;
